import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  forwardRef
} from '@angular/core';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.css']
})
export class TextInputComponent extends FormElementBase {
  constructor() {
    super();
  }
}
